<template>
    <div>
        <HeaderBg :title="$t('employmentApplications.jobDetails')" :description="$t('employmentApplications.requestNumberPrefix') + ' ' + application.id" />
        <RequestSpinner v-if="loadingRequest == true" />

        <div class="job_details_section">
            <div class="job_details_container">
                <table width="100%">
                    <thead>
                    <tr>
                        <th> {{$t('employmentApplications.requiredJob')}} </th>
                        <th>{{application.job}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>{{$t('employmentApplications.name')}}</td>
                        <td>{{application.name}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.idNumber')}}</td>
                        <td>{{application.id_number}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.expiryDate')}}</td>
                        <td>{{application.expiry_date}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.numberOfChildren')}}</td>
                        <td>{{application.number_of_children}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.maritalStatus')}}</td>
                        <td>{{application.marital_status}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.nationality')}}</td>
                        <td>{{application.nationality ? application.nationality.translation[0].name  : ''}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.homeAddress')}}</td>
                        <td>{{application.home_address}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.phone')}}</td>
                        <td>{{application.phone_number}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.email')}}</td>
                        <td>{{application.email}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.scientificQualifications')}}</td>
                        <td>{{application.scientific_qualifications}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.specialization')}}</td>
                        <td>{{application.specialization}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.schoolInstituteUniversity')}}</td>
                        <td>{{application.school_institute_university}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.graduationYear')}}</td>
                        <td>{{application.graduation_year}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.gpa')}}</td>
                        <td>{{application.gpa}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.yearsOfWork')}}</td>
                        <td>{{application.years_of_work}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.numberOfJobsWorked')}}</td>
                        <td>{{application.number_of_jobs_worked}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.company')}}</td>
                        <td>{{application.workplace}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.workplace')}}</td>
                        <td>{{application.workplace_country_city}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.jobTitle')}}</td>
                        <td>{{application.job_title}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.leavingWorkReason')}}</td>
                        <td>{{application.leaving_work_reason}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.mainTasks')}}</td>
                        <td>{{application.main_tasks}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.courseName')}}</td>
                        <td>{{application.course_name_1}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.partyOfCharge')}} </td>
                        <td>{{application.course_name_1_party_of_charge}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.courseName')}}</td>
                        <td>{{application.course_name_2}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.partyOfCharge')}}</td>
                        <td>{{application.course_name_2_party_of_charge}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.haveScfhsCert')}}</td>
                        <td>{{application.have_scfhs_accreditation_certificate == 0 ? $t('no') : $t('yes')}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.goodAtDriving')}} </td>
                        <td>{{application.good_at_driving_cars == 0 ? $t('no') : $t('yes')}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.haveDrivingLicense')}} </td>
                        <td>{{application.have_driving_license == 0 ? $t('no') : $t('yes')}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('employmentApplications.englishFluencyDegree')}}</td>
                        <td>
                            {{application.english_fluency_degree == 'excellent' ? $t('employmentApplications.excellent') : ''}}
                            {{application.english_fluency_degree == 'middle' ? $t('employmentApplications.middle') : ''}}
                            {{application.english_fluency_degree == 'weak' ? $t('employmentApplications.weak') : ''}}
                        </td>
                    </tr>
                    <tr v-for="(attachment, index) in application.attachments" :key="index">
                        <td>{{attachment.name}}</td>
                        <td> <a target="_blank" :href="attachment.download_url"> <img src="../../../assets/images/downloadSvg.svg" alt=""> </a> </td>
                    </tr>
                    <!-- <tr>
                        <td>صورة الهوية او جواز السفر</td>
                        <td> <a target="_blank" :href="application.attachments[0].download_url"> <img src="../../../assets/images/downloadSvg.svg" alt=""> </a> </td>
                    </tr>
                    <tr>
                        <td>السيرة الذاتية شهادة البكالوريوس</td>
                        <td> <a target="_blank" :href="application.attachments[1].download_url"> <img src="../../../assets/images/downloadSvg.svg" alt=""> </a> </td>
                    </tr>
                    <tr>
                        <td>شهادة البكالوريوس</td>
                        <td> <a target="_blank" :href="application.attachments[2].download_url"> <img src="../../../assets/images/downloadSvg.svg" alt=""> </a> </td>
                    </tr>
                    <tr>
                        <td> كارنية نقابة الصيادلة</td>
                        <td> <a target="_blank" :href="application.attachments[3].download_url"> <img src="../../../assets/images/downloadSvg.svg" alt=""> </a> </td>
                    </tr>
                    <tr>
                        <td>ترخيص مزاولة المهنة بوزارة الصحة بدولتك</td>
                        <td> <a target="_blank" :href="application.attachments[4].download_url"> <img src="../../../assets/images/downloadSvg.svg" alt=""> </a> </td>
                    </tr>
                    <tr>
                        <td>شهادات الخبرة 1</td>
                        <td> <a target="_blank" :href="application.attachments[5].download_url"> <img src="../../../assets/images/downloadSvg.svg" alt=""> </a> </td>
                    </tr>
                    <tr>
                        <td>شهادات خبرة 2</td>
                        <td> <a target="_blank" :href="application.attachments[6].download_url"> <img src="../../../assets/images/downloadSvg.svg" alt=""> </a> </td>
                    </tr>
                    <tr>
                        <td>شهادات خبرة 3</td>
                        <td> <a target="_blank" :href="application.attachments[7].download_url"> <img src="../../../assets/images/downloadSvg.svg" alt=""> </a> </td>
                    </tr>
                    <tr>
                        <td>صورة بيان الدرجات</td>
                        <td> <a target="_blank" :href="application.attachments[8].download_url"> <img src="../../../assets/images/downloadSvg.svg" alt=""> </a> </td>
                    </tr>
                    <tr>
                        <td> صورة من ترخيص مزاولة المهنة فى المملكة العربية السعدوية</td>
                        <td> <a target="_blank" :href="application.attachments[0].download_url"> <img src="../../../assets/images/downloadSvg.svg" alt=""> </a> </td>
                    </tr> -->
                    <tr>
                        <td> {{$t('employmentApplications.militaryStatus')}} </td>
                        <td> 
                            {{application.military_status == 'final_exemption' ? $t('employmentApplications.finalExemption') : ''}}
                            {{application.military_status == 'temp_exemption' ? $t('employmentApplications.tempExemption') : ''}}
                            {{application.military_status == 'performed_military_service' ? $t('employmentApplications.performedMilitaryService') : ''}}    
                        </td>
                    </tr>
                    
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import HeaderBg from '../../global/HeaderBg/HeaderBg'
import Request from '../../../services/Request';
import RequestSpinner from '../../global/loadingSpinners/RequestSpinner';
export default {
    name: 'JobDetails',
    components: {HeaderBg, RequestSpinner},
    data(){
        return{
            loadingRequest: true,
            application: {}
        }
    },
    mounted(){
        this.getApplication();
    },
    methods:{
        getApplication() {
            axios.get(`https://app.almujtama.com.sa/admin/employmentRequests/${this.$route.params.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': '*',
                    'Authorization': 'Bearer '+ localStorage.getItem('token'),
                    locale: 'ar'
                },
            })
            .then((response) => {
                this.application = response.data.data
                this.loadingRequest = false;
            })
            .catch((err) => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/')
                    localStorage.removeItem('token')
                }
            });
        },
    }
}
</script>
<style lang="scss" scoped>
.job_details_section{
    box-shadow: 0px 10px 50px #21343014;
    border-radius: 10px;
    padding: 20px;
    background-color: #F8F8F8;
    width: 700px;
    margin: auto;
    @media (max-width: 768px) {
        width: 100%;
    }
    .job_details_container{
        background-color: #FFF;
        padding: 20px;
        border-radius: 10px;
    }
}

table {
  width: 100%;
  font-size: 14px;
  border-collapse: collapse;
}

table thead th {
  color: #78A28F;
  padding: 15px;
  border-bottom: 2px solid #ebebec;
  font-weight: 500;
}
table thead th:last-child{
    border-left: 0;
}

table tr {
  background: #ffffff;
}

table tr td {
    border-bottom: 2px solid #e6edf1;
    padding: 15px;
    color: #78A28F;
    font-weight: 600;
}


</style>